export const formatCurrency = (value) => {
    if (value == null || value === false || value === true) return '';
    if (typeof value !== 'string') value = String(value);
    
    const numericalValue = parseFloat(value.replace(/[^\d.-]/g, ''));
    if (isNaN(numericalValue)) return '';
  
    return numericalValue.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  };
  